module.exports = __webpack_public_path__ + "static/img/question4-2.4f12666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-2.png
// module id = 6eCe
// module chunks = 1